module.exports = __webpack_public_path__ + "assets/img/chronicleImg-e4a3b1ff.png";